// ===============================
// features/appbar/hooks/useSearchSuggestions.js
// ===============================
import { useState, useMemo } from "react";
import { SUGGESTIONS } from "../utils/utils";

export function useSearchSuggestions() {
  const [searchOpen, setSearchOpen] = useState(false);
  const [searchValue, setSearchValue] = useState("");

  const filteredSuggestions = useMemo(() => {
    return SUGGESTIONS.filter((item) => item.includes(searchValue));
  }, [searchValue]);

  return {
    searchOpen,
    setSearchOpen,
    searchValue,
    setSearchValue,
    filteredSuggestions,
  };
}
